<template>
    <div :style="listHeight">
        <el-scrollbar style="height:100%;">
        <div class="lr-timeline-allwrap">
            
                <ul style="padding-left: 5px;">
                    <li class="lr-timeline-header">
                        <div>开始</div>
                    </li>
                    <li v-for="(item,index) in taskRecord" :key="item.ID" class=" lr-timeline-item">
                        <div v-bind:class="['lr-timeline-wrap', index===0? 'lr-timeline-current':'']">
                            <span class="lr-timeline-date">{{item.OPERATETIME| timeFormater}}</span>
                            <div class="lr-timeline-content"><span class="arrow">
                                                </span>
                                <div class="lr-timeline-title">{{item.KEYPOINTNAME}}</div>
                                <div class="lr-timeline-body" v-if="item.MEMO" v-html="item.MEMO"></div>
                            </div>
                        </div>
                    </li>
                    <!-- <li class="lr-timeline-item">
                                    <div class="lr-timeline-wrap"><span class="lr-timeline-date">2018-10-08 10:18:38</span>
                                        <div class="lr-timeline-content"><span class="arrow"></span>
                                            <div class="lr-timeline-title">更新状态（执行中）</div>
                                            <div class="lr-timeline-body"><span>肖亮:</span>通过【备注】任务处理</div>
                                        </div>
                                    </div>
                                </li> -->
                    <li class="lr-timeline-ender">
                        <div>当前</div>
                    </li>
                </ul>
        </div>
            </el-scrollbar>
    </div>
</template>

<script>
    import {
        GetAllTaskKeyPointsByTaskId
    } from "@/api/modules/basicData/task";
    export default {
        data() {
            return {
                taskRecord: []
            }
        },
        methods: {
            initalTask: function() {
                if (!this.task.ID || this.tabIndex !== '2') return;
                GetAllTaskKeyPointsByTaskId(this.task.ID).then(res => {
                    if (!res) return;
                    this.taskRecord = res;
                });
            }
        },
		created() {
			let a = $(window).height();
			this.listHeight = "height:" + (a - 150) + "px;";
		},
        computed: {
            task: function() {
                return this.$store.state.task.curTask;
            },
            tabIndex: function() {
                return this.$store.state.task.tabIndex;
            },
        },
        watch: {
            task: function(newvalue) {
                if (!newvalue) return;
                this.initalTask();
            },
            tabIndex: function(newvalue) {
                if (!newvalue) return;
                this.initalTask();
            }
        }
    };
</script>

<style scoped>
    @import "../../../styles/track.css";
</style>